<script setup>
import { onMounted, onBeforeUnmount, computed } from "vue";
import { useRoute } from "vue-router";
import { t, useGlobusLocal } from "@/controllerLK/GlobusLocalization";
import { useStore } from "@/store";
import LanguageSelector from "./LoginPage/LanguageSelector.vue";
import MaintenanceIcon from "@/assets/icons/MaintenanceIcon.vue";

const { initGlobusLocal } = useGlobusLocal();
const store = useStore();
const route = useRoute();

const endTime = computed(() => {
  return route.query.endTime || t("under_construction.time_value");
});

onMounted(() => {
  document.getElementById("appMain").classList.add("login-theme");
  initGlobusLocal(store.language.code, "personal_area");
});

onBeforeUnmount(() => {
  document.getElementById("appMain").classList.remove("login-theme");
});
</script>

<template>
  <div class="under-construction">
    <div class="under-construction__card">
      <div class="under-construction__header">
        <LanguageSelector />
      </div>
      <div class="under-construction__body">
        <div class="under-construction__icon">
          <MaintenanceIcon />
        </div>
        <h1 class="under-construction__title">
          {{ t('under_construction.title') }}
        </h1>
        <p class="under-construction__description">
          {{ t('under_construction.description') }}
        </p>
        <p class="under-construction__time">
          {{ t('under_construction.time_label') }}
          <span class="under-construction__time-value">
            {{ endTime }}
          </span>
        </p>
        <p class="under-construction__contact">
          {{ t('under_construction.contact_text') }}<br>
          {{ t('under_construction.contact_prefix') }} <a
            href="mailto:support@globus.guru"
            class="under-construction__email"
          >support@globus.guru</a>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.under-construction {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: #09518C;
  line-height: 1;

  &__card {
    display: flex;
    flex-direction: column;
    width: 588px;
    height: 480px;
    padding: 24px 37px;
    border-radius: 20px;
    background: #FFF;
  }

  &__header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 52px;
  }

  &__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  &__icon {
    width: 100px;
    height: 100px;
    margin-bottom: 26px;
  }

  &__title {
    margin: 0 0 16px;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.3;
    color: #212327;
  }

  &__description {
    margin: 0 0 18px;
    max-width: 472px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.4;
    color: #373D3F;
  }

  &__time {
    margin: 0 0 18px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.4;
    color: #212327;
  }

  &__time-value {
    font-size: 16px;
    font-weight: 700;
  }

  &__contact {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.4;
    color: #373D3F;
  }

  &__email {
    font-size: 16px;
    text-decoration: none;

    &:hover {
      color: #1F9AFF;
      text-decoration: underline;
    }
  }
}
</style>
